import styled from "styled-components";
import { colors } from "assets";

export default c => styled(c)`
  .timeline__content > div {
    margin: 0 !important;
    padding: 4px 8px !important;
  }

  .timeline__content .card-value p {
    font-size: 15px !important;
  }

  .sale-canceled {
    color: ${colors.accent.normal};
    font-size: 14px;
    font-weight: bold;
  }
`;



// WEBPACK FOOTER //
// ./src/components/app/history/sales/timeline/styles.js